import { Text, Tooltip } from '@mantine/core';

/** Render a text cell with truncation and tooltip for overflow */
export function renderTextCell(
  value: string | null | undefined,
  maxWidth?: number,
) {
  if (!value) {
    return (
      <Text fz={13} c="dimmed">
        &mdash;
      </Text>
    );
  }
  return (
    <Tooltip
      label={value}
      disabled={value.length < 25}
      position="top-start"
      multiline
      maw={300}
    >
      <Text fz={13} truncate="end" maw={maxWidth || 'none'}>
        {value}
      </Text>
    </Tooltip>
  );
}
